export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";